import React from 'react';
import TableWrapper from '../TableWrapper';
import UsersTableContent from './table/UsersTableContent';
import UsersTableHeader from './table/UsersTableHeader';
import type { Project, User } from '../../../types';

type Props = {
  users: Array<User>,
  selectedRole: string,
  selectedProjectId: number,
  isAdmin?: boolean,
  isOwner?: boolean,
  onEditModalOpen: (user: User) => void,
  onAddModalOpen: () => void,
  onSelectRoleChange: (role: string) => void,
  onSelectProjectChange: (projectId: number) => void,
  onSearchUsersSubmit: () => void,
  onSearchUsersReset: () => void,
  onInactiveChange: (inactive: boolean) => void,
  onStudentChange: (student: boolean) => void,
  roles: Array<any>,
  projects: Array<Project>,
  searchTriggered: boolean,
  triggeredRole: string,
  triggeredProjectId: any,
  inactive: boolean,
  student: boolean,
};

const UsersContent = (props: Props) => {
  const {
    users,
    selectedRole,
    selectedProjectId,
    onEditModalOpen,
    onAddModalOpen,
    onSelectRoleChange,
    onSelectProjectChange,
    onSearchUsersSubmit,
    onSearchUsersReset,
    roles,
    projects,
    searchTriggered,
    triggeredRole,
    triggeredProjectId,
    onInactiveChange,
    onStudentChange,
    inactive,
    student,
  } = props;

  return (
    <TableWrapper
      className="small-device-user has-custom-table"
    >
      <UsersTableHeader
        selectedRole={selectedRole}
        selectedProjectId={selectedProjectId}
        onSelectRoleChange={onSelectRoleChange}
        onSelectProjectChange={onSelectProjectChange}
        onSearchUsersSubmit={onSearchUsersSubmit}
        onSearchUsersReset={onSearchUsersReset}
        onInactiveChange={onInactiveChange}
        onStudentChange={onStudentChange}
        inactive={inactive}
        student={student}
        roles={roles}
        projects={projects}
        searchTriggered={searchTriggered}
        triggeredRole={triggeredRole}
        triggeredProjectId={triggeredProjectId}
      />
      <UsersTableContent
        users={users}
        onEditModalOpen={onEditModalOpen}
        onAddModalOpen={onAddModalOpen}
      />
    </TableWrapper>
  );
};

export default UsersContent;
